import { Skeleton } from "@ui/skeleton";
import React from "react";

const CertificateCardSkeleton = () => {
  return (
    <div className="flex cursor-pointer flex-col items-start justify-start gap-y-1 rounded-br-[20px] rounded-tl-[20px] border border-navy-blue px-4 py-3 dark:border-primary dark:bg-black/15">
      <Skeleton className="h-[111px] w-[250px]" />
      {/* <img
        src={"/assets/images/certificate.png"}
        alt="no certificate"
        width={250}
        height={111}
      /> */}
      <div className="flex w-full flex-col items-center justify-center gap-y-2 p-3">
        <Skeleton className="h-[12px] w-[150px]" />
        <Skeleton className="h-[12px] w-[120px]" />

        {/* <div className="text-[20px] font-medium">{skillName}</div> */}
        {/* <div className="text-[13px] text-[#91959C]">{date}</div> */}
      </div>
    </div>
  );
};

export default CertificateCardSkeleton;
